module.exports = __webpack_public_path__ + "img/close_btn.09e9f945.png";